module.exports = __webpack_public_path__ + "img/revolts_1.f707b3a.jpg";